import {
  Button,
  Container,
  ContainerTile,
  H1,
  HeaderWithDisclaimerContainer,
  RowWrapper,
  SubText,
  Tile,
  Wrapper,
} from "components/styled-components/generic";
import { Tooltip } from "components/styled-components/tooltip";
import { availableChargers } from "constants/chargers";
import { disclaimerCharger } from "constants/disclaimers";
import useCheckIfMobile from "helpers/check-if-mobile";
import { FC } from "react";
import { Charger } from "shared-types";

export interface ChargersProps {
  selectedCharger: Charger | undefined;
  setSelectedCharger: (charger: Charger) => void;
}

export const Chargers: FC<ChargersProps> = ({
  selectedCharger,
  setSelectedCharger,
}) => {
  const isMobile = useCheckIfMobile();
  const buttonHeight = isMobile ? "65px" : "55px";

  return (
    <ContainerTile>
      <Wrapper>
        <HeaderWithDisclaimerContainer>
          <H1>Ladestation</H1>
          <Tooltip id="charger" tip={disclaimerCharger} />
        </HeaderWithDisclaimerContainer>
      </Wrapper>
      <RowWrapper wrap justify="center" gap="10px">
        {availableChargers.map((charger) => {
          return (
            <Tile style={{ margin: 0 }} key={charger.id}>
              <Button
                width="160px"
                fixedWidth
                height={buttonHeight}
                onClick={() => {
                  setSelectedCharger(charger);
                }}
                active={selectedCharger && charger.id === selectedCharger.id}
              >
                {charger.name}
              </Button>
            </Tile>
          );
        })}
      </RowWrapper>
      <SubText style={{ padding: "0 15px" }} textAlign="start">
        {selectedCharger?.disclaimer}
      </SubText>
    </ContainerTile>
  );
};
